/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Service from '../Util/Service';
import $ from '../Util/Util';
import FolderOpenIcon from './opened-folder.png';
import FolderCloseIcon from './closed-folder.png';
import './Folderselector.css';

/**
 * Represents a folder selector component.
 */

export default class Folderselector extends Component {

    /**
     * Properties.
     */

    static propTypes = {
        context:             PropTypes.object.isRequired,        
        onSelect:            PropTypes.func.isRequired,
        onLoading:           PropTypes.func.isRequired
    }

    /**
     * Default state.
     */

     state = {
         folders:           [],
         folderlist:        [],
         selected:          null
     }

     /**
      * Event that fires when the user toggles a folder.
      * 
      * @param  {Object}    folder      folder that is toggled
      */

    _toggleFolder = (folder) => {

        // Getting the DOM folder and the visibility state

        let fld = ReactDOM.findDOMNode(this['foldercontent_' + folder.id]);
        let state = fld.style.display !== 'none';

        // Toggling the icon of the folder

        ReactDOM.findDOMNode(this['foldericon_' + folder.id]).src = state ? FolderCloseIcon : FolderOpenIcon;
        
        // Refreshing the folders

        fld.style.display = (state ? 'none' : '');

        this.setState({ selected: folder });
        this.props.onSelect(folder);
    }

    /**
     * Selects the specified folder by id.
     * 
     * @param   {String}    folder      ID of the folder
     */

    select = (folder) => {

        // Preparing

        if (!folder) {
            return;
        }
        
        let path = folder.split('/');
        let id = path[path.length - 1];
        
        // Opening the folders

        path.forEach((p) => {
            if (p !== 'folders') {
                let f = ReactDOM.findDOMNode(this['foldercontent_' + p]);

                if (f) {
                    ReactDOM.findDOMNode(this['foldericon_' + p]).src = FolderOpenIcon;
                    f.style.display = '';
                }
            }
        });

        // Selecting the folder and scrolling to it

        this.setState({ selected: { id: id , path: path } }, () => {
            let f = ReactDOM.findDOMNode(this['folder_' + id]);

            if (f) {
                f.scrollIntoView(false);
            }
        });
    }

    /**
     * Selects the first available folder.
     */

    selectFirst = () => {
        if (this.state.folders && this.state.folders.length > 0) {
            this.select(this.state.folders[0].id);
            this.props.onSelect(this.state.folders[0]);
        }
    }

    /**
     * Loads the folder tree that is available for the current user.
     * 
     * @return  {Promise}   promise     promise object
     */

    load = () => {

        // Creating and returning the promise object

        return new Promise((resolve, reject) => {

            // Showing progress indicator

            this.props.onLoading(true);

            // Getting the folders

            Service.loadFolder(this.props.context.user.admin ? null : this.props.context.user.group.id).then((folders) => {

                // Storing the folder tree and the list

                this.setState({ folders: folders });

                // Hiding progress indicator

                this.props.onLoading(false);

                // Resolving

                resolve();
            }).catch((error) => {

                // Hiding progress indicator

                this.props.onLoading(false);

                // Showing error

                $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });

                // Rejecting

                reject();
            });
        });
    }

    /** 
     * Folder selector renderer.
     */

    render() {

        /**
         * Renders the folder tree.
         * 
         * @param {Array}   folder  folders that has to render 
         * @param {Number}  level   current folder level 
         */

        let renderFolder = (folder, level) => {
            return (
                folder.map((item, index) => {
                    return (
                        <div key={item.id} style={{ position: 'relative', left: (level === 1 ? 0 : 32) + 'px', width: `calc(100% - ${level === 1 ? 0 : 32}px)` }}>

                            {/* Folder icon and name */}

                            <div ref={c => {this['folder_' + item.id] = c;}} className={`folderselector-folder ${(this.state.selected && this.state.selected.id === item.id) ? 'folderselector-selectedfolder' : 'folderselector-unselectedfolder'}`} onClick={this._toggleFolder.bind(this, item)}>
                                <div className="horizontal center">
                                    <img ref={c => {this['foldericon_' + item.id] = c;}} alt="Folder" src={FolderCloseIcon} className="folderselector-folder-icon" />
                                    <div className="folderselector-folder-label">{item.name}</div>
                                </div>
                            </div>

                            {/* Subfolders of the folder */}

                            <div ref={c => {this['foldercontent_' + item.id] = c;}} style={{ display: 'none' }}>
                                { item.folders && renderFolder(item.folders, level + 1)}
                            </div>
                        </div>
                    );                    
                })
            );
        };

        return (

            /* Folder tree container*/

            <div ref={c => {this.root = c;}} className="folderselector">

                {/* Folder tree */}

                <div className="folderselector-folder-container vertical">
                    { renderFolder(this.state.folders, 1) }
                </div>
            </div>
        )
    }    
}



// WEBPACK FOOTER //
// ./src/components/Folderselector/Folderselector.js